module.exports = __webpack_public_path__ + "img/embed-base.ce2e9b85.png";